<template>
    <router-view></router-view>
</template>
<script>
 export default {
  name: 'quickListPage',
  data() {
      return {

      }
  },
  methods: {

  },

} 
</script>
